<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditReasonModal"
        persistent
        max-width="500px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              >
                <span class="headline">
                  {{ isUpdate ? 'Update Reason' : 'Add New Reason' }}
                </span>
              </v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Cancel Reason English*"
                    v-model="formData.cancel_reason"
                    :error-messages="errors.collect('cancel_reason')"
                    v-validate="'required'"
                    data-vv-name="cancel_reason"
                  /></v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Cancel Reason Arabic*"
                      v-model="formData.cancel_reason_ar"
                      :error-messages="errors.collect('cancel_reason_ar')"
                      v-validate="'required'"
                      data-vv-name="cancel_reason_ar"
                    /></v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Cancel Reason Kurdish*"
                      v-model="formData.cancel_reason_ku"
                      :error-messages="errors.collect('cancel_reason_ku')"
                      v-validate="'required'"
                      data-vv-name="cancel_reason_ku"
                    />
                  </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 2%"
                outline
                color="success"
              >
                {{ isUpdate ? 'Save' : 'Add' }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['addEditReasonModal', 'formData', 'isUpdate'],

  data() {
    return {
      loading: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isUpdate) {
            Axios.put(`api/reason/${this.formData.reason_id}`, this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: 'Updated successfully',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal('Error', error.response.data.message, 'error')
              })
          } else {
            Axios.post('api/reason', this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: 'Added successfully',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal('Error', error.response.data.message, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CancellationReason/addEditReason.vue